module.exports = "/next-static/_next/static/images/repurposeAndShare-7d62e7c6db26400815cf7f742e232a27.png";